export default function Menu({ menuStatus }) {
  return (
    <>
      <nav className={`menu ${menuStatus ? "open" : ""} `}>
        <a
          href="#services"
          className="menu__content menu__services link__hover-effect"
        >
          Services
        </a>
        <a
          href="#projects"
          className="menu__content menu__projects link__hover-effect"
        >
          Projects
        </a>
        <a
          href="#testimonials"
          className="menu__content menu__testimonials link__hover-effect"
        >
          Proof
        </a>
        <a
          href="#contact"
          className="menu__content menu__contact link__hover-effect"
        >
          Contact
        </a>
      </nav>
    </>
  );
}
